import { render, staticRenderFns } from "./clientUsersAddModal.vue?vue&type=template&id=96218bca&scoped=true"
import script from "./clientUsersAddModal.vue?vue&type=script&lang=js"
export * from "./clientUsersAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96218bca",
  null
  
)

export default component.exports